import React, { useState, useEffect } from "react";

import { Button } from "@material-ui/core";
import firebase from "../../helpers/firebase";
import { deleteCollection } from "../../helpers/firebaseCRUD";
import CircularProgress from "@material-ui/core/CircularProgress";
import createId from "../../helpers/createId";
import { Link } from "react-router-dom";
import { localStore } from "../../helpers/localStorage";

const InstructorHome = () => {
  const [students, setStudents] = useState("0");
  const [sessionId, setSessionId] = useState(null);
  const [sessionCreated, setSessionCreated] = useState(false);
  const db = firebase.firestore();
  let retryTimes = 0;
  let sessionLength = 2;

  useEffect(() => {
    try {
      if (!sessionId) {
        createSession();
      }
    } catch (err) {
      console.log(err);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const createSession = async () => {
    try {
      let id = createId(sessionLength);

      let session = db.collection("sessions").doc(id);

      session.get().then(async (docSnapshot) => {
        if (!docSnapshot.exists) {
          rewriteSession(session);
        } else {
          let lastUpdated = docSnapshot.data().time;
          let currentTime = Math.floor(new Date().getTime() / 1000);
          let timeDifference = currentTime - lastUpdated;
          if (timeDifference > 0) {
            await deleteCollection(`sessions/${id}/answers`);
            await deleteCollection(`sessions/${id}/students`);
            rewriteSession(session);
          } else {
            console.log("trying to create session again");
            retrySession();
          }
        }
      });
    } catch (err) {
      console.log(err);
    }
  };

  const retrySession = () => {
    retryTimes += 1;
    if (retryTimes > 5) {
      sessionLength += 1;
    }
    createSession();
  };

  const rewriteSession = async (session) => {
    return session
      .set({
        status: "WAITING_STUDENTS",
        time: Math.floor(new Date().getTime() / 1000),
      })
      .then(() => {
        setSessionId(session.id);
        localStore.setSession(session.id);
        setSessionCreated(true);
        watchStudents(session.id);
      });
  };

  const watchStudents = (id) => {
    db.collection("sessions")
      .doc(id)
      .collection("students")
      .onSnapshot((doc) => {
        setStudents(doc.docs.length);
      });
  };

  const ConnectedStudents = () => (
    <>
      <div style={{ margin: "auto" }} />
      <div className="sessionContainer">
        <div className="sessionHeader">
          <h1>{sessionId}</h1>
        </div>
          <p className="sessionSubTitle">session Id</p>
      </div>
      <div className="studentCountWrapper">
        <div className="studentCount">
          <h1>{students}</h1>
          <p>
            students logged In
          </p>
        </div>
        <div>
          <Link to="/instructor/new_exercise">
            <Button
              className="CustomButton w100"
              variant="contained"
              size="large"
            >
              Start Web App
            </Button>
          </Link>
        </div>
      </div>
      <div style={{ margin: "auto" }} />
    </>
  );

  const Loading = () => (
    <>
      <CircularProgress />
      <h2>Creating a session...</h2>
    </>
  );

  return <>{sessionCreated ? <ConnectedStudents /> : <Loading />}</>;
};

export default InstructorHome;
